// Utilidades de formato (fechas, precios, cuenta atrás)
import { COUNTRY_LABELS } from '../data/constants.js'

// Formatea un número como moneda EUR usando el locale alemán
// (máximo 2 decimales; se muestra como llega del auktionshaus)
export function formatPrice(value, currency = 'EUR') {
  if (value === null || value === undefined) return '–'
  const num = Number(value)
  if (Number.isNaN(num)) return '–'
  return new Intl.NumberFormat('de-DE', {
    style: 'currency',
    currency: currency || 'EUR',
    maximumFractionDigits: 0
  }).format(num)
}

// Formatea una fecha ISO a formato legible alemán (o relativo)
export function formatDate(iso) {
  if (!iso) return '–'
  const d = new Date(iso)
  if (Number.isNaN(d.getTime())) return '–'
  return new Intl.DateTimeFormat('de-DE', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  }).format(d)
}

// Diferencia en milisegundos entre ahora y un instante futuro
function diffUntil(iso) {
  const target = new Date(iso).getTime()
  return target - Date.now()
}

// Cuenta atrás simple: devuelve objeto {days, hours, mins, secs, ended}
export function countdown(iso) {
  const diff = diffUntil(iso)
  if (!iso || Number.isNaN(diff) || diff <= 0) {
    return { days: 0, hours: 0, mins: 0, secs: 0, ended: true }
  }
  const totalSecs = Math.floor(diff / 1000)
  return {
    days: Math.floor(totalSecs / 86400),
    hours: Math.floor((totalSecs % 86400) / 3600),
    mins: Math.floor((totalSecs % 3600) / 60),
    secs: totalSecs % 60,
    ended: false
  }
}

// Texto corto de cuenta atrás ("3T 04:12:33")
export function formatCountdown(iso) {
  const c = countdown(iso)
  if (c.ended) return 'Beendet'
  const hh = String(c.hours).padStart(2, '0')
  const mm = String(c.mins).padStart(2, '0')
  const ss = String(c.secs).padStart(2, '0')
  return c.days > 0 ? `${c.days}T ${hh}:${mm}:${ss}` : `${hh}:${mm}:${ss}`
}

// Nombre de país a partir del código en ALEMÁN (fallback: Intl.DisplayNames de)
export function countryName(code) {
  if (!code) return 'Unbekannt'
  const key = String(code).toLowerCase()
  if (COUNTRY_LABELS[key]) return COUNTRY_LABELS[key]
  try {
    return new Intl.DisplayNames(['de'], { type: 'region' }).of(code.toUpperCase()) || code.toUpperCase()
  } catch (_) {
    return code.toUpperCase()
  }
}

// Nombre de casa de subastas legible desde el objeto source
// (el frontend no depende de esto: la API manda nombre)
export function sourceName(source) {
  if (!source) return 'Auktionshaus'
  return (source.name || source.code || 'Auktionshaus').replace(/\s+Auctions$/, '').trim()
}
